import { isBrandRefreshEnabled } from '../utilities/brandRefresh';

const useBrandRefresh = () => ({
  isBrandRefresh: isBrandRefreshEnabled(),
});

export default useBrandRefresh;
